// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Breadcrumbs_wrapper__2deg2","link":"Breadcrumbs_link__HEHp4","inactive":"Breadcrumbs_inactive__OH1Wd","slash":"Breadcrumbs_slash__yS_rK"};